import React, {useRef, useEffect } from 'react'
import videoHi from '../images/3.mp4';

export default function VideoScroll({boundRefP})
{
    const videoRef = useRef(null);
    const boundRef = useRef(boundRefP);

    const registerVideo = () => {
        const scrollVideo = ()=>{
            if(videoRef.current!==null && videoRef.current.duration) {
                const distanceFromTop = window.scrollY + boundRef.current.current.getBoundingClientRect().top;
                const rawPercentScrolled = (window.scrollY - distanceFromTop) / (boundRef.current.current.scrollHeight - window.innerHeight);
                const percentScrolled = Math.min(Math.max(rawPercentScrolled, 0), 1);
                
                videoRef.current.currentTime = videoRef.current.duration * percentScrolled;
            }
            requestAnimationFrame(scrollVideo);
        }
        requestAnimationFrame(scrollVideo);
    }

    useEffect(function(){
        registerVideo();
    }, [])

    return(
        <div className="wrapper-video">
            <div id="bound-one" className="scroll-bound" >
                <div className="content">
                    <video width="100%" muted preload="true" ref={videoRef}>
                        <source src={videoHi} type="video/mp4" />
                        <p>Your user agent does not support the HTML5 Video element.</p>
                    </video>
                </div>
            </div>	
        </div>
    )
}